import { render, staticRenderFns } from "./MobileExamCard.vue?vue&type=template&id=0708f32d&scoped=true&"
import script from "./MobileExamCard.vue?vue&type=script&lang=js&"
export * from "./MobileExamCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileExamCard.vue?vue&type=style&index=0&id=0708f32d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0708f32d",
  null
  
)

export default component.exports